import { registerLocaleData } from "@angular/common";
import localePt from "@angular/common/locales/pt";
import { LOCALE_ID, NgModule, provideZoneChangeDetection } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { HttpModule } from "@angular/http";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouteReuseStrategy } from "@angular/router";
import { ToastyModule } from "ng2-toasty";
import { NgxMaskDirective, NgxMaskPipe, provideEnvironmentNgxMask } from 'ngx-mask';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from "@angular/common/http";
import { NgProgressbar } from "ngx-progressbar";
import { NgProgressHttp, progressInterceptor } from "ngx-progressbar/http";
import { NgProgressRouter } from "ngx-progressbar/router";
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { SharedModule as PrimeSharedModule } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { CoreModule } from "./core/core.module";
import { UploadServiceModule } from "./core/upload-service/upload-service.module";
import { CronogramaFinanceiroModule } from "./cronograma-financeiro/cronograma-financeiro.module";
import { EmendaParlamentarModule } from "./emenda-parlamentar/emenda-parlamentar.module";
import { HomeModule } from "./home/home.module";
import { MapaModule } from "./mapa/mapa.module";
import { NoticiasModule } from "./noticias/noticias.module";
import { OutrasOpcoesModule } from "./outras-opcoes/outras-opcoes.module";
import { PendenciaModule } from "./pendencia/pendencia.module";
import { PrestacaoContasModule } from "./prestacao-contas/prestacao-contas.module";
import { PropostaModule } from "./proposta/proposta.module";
import { RepassesModule } from "./repasses/repasses.module";
import { SegurancaModule } from "./seguranca/seguranca.module";
import { TutoriaisModule } from "./tutoriais/tutoriais.module";
import { WrapperModule } from "./wrapper/wrapper.module";
import { AssinadorDocumentosModule } from "./assinador-documentos/assinador-documentos.module";
import { CriptoService } from "./core/services/utils/cripto.service";
import { ListStateReuseStrategy } from "./core/routing/list-state-reuse.strategy";

import { SharedsModule } from './shareds/shareds.module';

registerLocaleData(localePt);

@NgModule({
  declarations: [AppComponent],
  imports: [
    SharedsModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpModule,
    FormsModule,
    CoreModule,

    ConfirmDialogModule,
    PrimeSharedModule,

    NgxMaskDirective, NgxMaskPipe,
    ToastyModule.forRoot(),

    NgProgressbar,
    NgProgressHttp,
    NgProgressRouter,

    AppRoutingModule,
    WrapperModule,
    HomeModule,
    UploadServiceModule,
    SegurancaModule,

    CronogramaFinanceiroModule,
    EmendaParlamentarModule,
    NoticiasModule,
    RepassesModule,
    PrestacaoContasModule,
    MapaModule,
    OutrasOpcoesModule,
    PendenciaModule,
    PropostaModule,
    TutoriaisModule,

    AssinadorDocumentosModule,
  ],
  providers: [
    // O Angular 21 é zoneless por padrão: `ZONELESS_ENABLED` nasce com `factory: () => true`.
    // Esta aplicação foi escrita para o modo com zone.js — as telas atribuem um campo dentro de
    // um `.then()` e contam com o redesenho automático. Sem esta linha nada as marca como sujas,
    // e a tela segue mostrando o spinner até que algo mais notifique o agendador: um clique, ou
    // a próxima requisição HTTP. Medido antes da correção: a lista de parcerias só aparecia aos
    // **28 segundos**, quando o contador de mensagens do cabeçalho dispara (ADR-0080 §3.1).
    provideZoneChangeDetection(),
    { provide: LOCALE_ID, useValue: "pt-BR" },
    provideHttpClient(withInterceptorsFromDi(), withInterceptors([progressInterceptor])),
    provideEnvironmentNgxMask(),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: false,
        },
      },
    }),
    CriptoService,
    { provide: RouteReuseStrategy, useClass: ListStateReuseStrategy },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
